<div
    role="group"
    class="agpr-formField"
    [ngClass]="{ 'agpr-textStyleField-container': field.isPrimary }"
    [class.agpr-textStyleField--headlinesVariant]="layoutVariant === 'headlines'"
    [class.agpr-textStyleField--insightsVariant]="layoutVariant === 'insights'"
    [class.agpr-textStyleField--backToTopLinksVariant]="layoutVariant === 'backToTopLinks'"
    [class.agpr-textStyleField--sectionHeadingVariant]="layoutVariant === 'sectionHeading'"
    [attr.aria-label]="field.label | localize"
>
    @if (showLabel) {
        <div
            [ngClass]="{
                'agpr-formField-heading': field.isPrimary,
                'agpr-formField-subheading': !field.isPrimary,
                'agpr-formField-subheading--compact': !field.isPrimary && subheadingSpacing === 'compact',
                'agpr-formField-subheading--none': !field.isPrimary && subheadingSpacing === 'none'
            }"
        >
            @if (smallLabel) {
                <label class="agpr-formField-headingLabelSmall">
                    {{ field.label | localize }}
                </label>
            } @else {
                <label class="agpr-formField-headingLabel">
                    {{ field.label | localize }}
                </label>
            }
            @if (field.isPrimary) {
                <div class="agpr-formField-headingButtons">
                    @if (field.allowExpertMode) {
                        <agpr-button
                            class="agpr-formField-headingButton"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-code"
                            tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                            tooltipPosition="top"
                            (click)="saveExpertTemplate()"
                        ></agpr-button>
                    }
                    <agpr-button
                        class="agpr-formField-headingButton"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-floppy-disk"
                        tooltip="PageBuilder.formField.tooltip.saveStyle"
                        tooltipPosition="top"
                        (click)="saveStyle()"
                    ></agpr-button>
                </div>
            }
        </div>
    }

    @if (field.showStyleState) {
        <div class="agpr-textStyleField-styleState">
            <div class="agpr-inputGroupRow">
                <div class="agpr-inputGroupRow-dropdown">
                    <agpr-dropdown-field
                        [id]="id + '_styleStateDropdown'"
                        [value]="value.displayStyleState"
                        [field]="styleStateField"
                        [updateOptions]="styleStateField.options"
                        [labelClass]="'agpr-dropdown-label--semibold'"
                        (changes)="setStyle($event, styleStateField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-inputGroupRow-buttons">
                    <agpr-button
                        [id]="id + '_manageStyles'"
                        [style]="buttonTypes.block"
                        icon="fa-regular fa-duotone fa-gear"
                        tooltip="PageBuilder.formField.tooltip.manageStyles"
                        (click)="manageStylesButtonClicked()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    }

    @if (!value.template) {
        <div
            class="agpr-textStyleField"
            [ngClass]="{
                'agpr-textStyleField-content': field.isPrimary,
                'agpr-textStyleField-subContent': !field.isPrimary
            }"
        >
            <div class="agpr-textStyleField-fieldRow">
                <div class="agpr-textStyleField-fieldRow-item">
                    <agpr-dropdown-field
                        class="agpr-textStyleField-font"
                        [id]="id + '_fontFamilyDropdown'"
                        [value]="value.fontFamily"
                        [field]="fontFamilyField"
                        inputTooltip="PageBuilder.formField.tooltip.fontName"
                        (changes)="setStyle($event, fontFamilyField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-textStyleField-textFormattingButtons">
                    <agpr-checkbox
                        class="agpr-textStyleField-button"
                        [id]="id + '_textStyleField_bold'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-bold"
                        tooltip="PageBuilder.formField.tooltip.bold"
                        [(ngModel)]="value.bold"
                        (onChange)="setStyle($event, 'bold')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-textStyleField-button"
                        [id]="id + '_textStyleField_italics'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-italic"
                        tooltip="PageBuilder.formField.tooltip.italics"
                        [(ngModel)]="value.italics"
                        (onChange)="setStyle($event, 'italics')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-textStyleField-button"
                        [id]="id + '_textStyleField_underline'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-underline"
                        tooltip="PageBuilder.formField.tooltip.underline"
                        [(ngModel)]="value.underlined"
                        (onChange)="setStyle($event, 'underlined')"
                    ></agpr-checkbox>
                </div>
            </div>

            @if (field.showFontSizeDropdown && !field.showAlignmentButtons && !field.showBackgroundColor && !field.customBackgroundColorTemplate) {
                <div class="agpr-textStyleField-fieldRow">
                    <div class="agpr-textStyleField-fontSize">
                        <div
                            class="agpr-textStyleField-fontSizeIcon"
                            [pTooltip]="'PageBuilder.formField.tooltip.fontSize' | localize"
                        >
                            <span class="agpr-i-font-size" aria-hidden="true"></span>
                        </div>
                        <agpr-dropdown-field
                            class="agpr-textStyleField-fontSizeDropdown"
                            [id]="id + '_fontSizeDropdown'"
                            [value]="value.fontSize"
                            [field]="fontSizeField"
                            (changes)="setStyle($event, fontSizeField.property)"
                        ></agpr-dropdown-field>
                    </div>
                    <div class="agpr-textStyleField-fieldRow-item">
                        <agpr-color-picker-field
                            [id]="id + '_textColorPicker'"
                            [field]="colorPickerField"
                            [value]="value.color"
                            (changes)="setStyle($event, colorPickerField.property)"
                        ></agpr-color-picker-field>
                    </div>
                </div>
            } @else {
                <div class="agpr-textStyleField-fieldRow">
                    @if (field.showFontSizeDropdown) {
                        <div class="agpr-textStyleField-fontSize">
                            <div
                                class="agpr-textStyleField-fontSizeIcon"
                                [pTooltip]="'PageBuilder.formField.tooltip.fontSize' | localize"
                            >
                                <span class="agpr-i-font-size" aria-hidden="true"></span>
                            </div>
                            <agpr-dropdown-field
                                class="agpr-textStyleField-fontSizeDropdown"
                                [id]="id + '_fontSizeDropdown'"
                                [value]="value.fontSize"
                                [field]="fontSizeField"
                                (changes)="setStyle($event, fontSizeField.property)"
                            ></agpr-dropdown-field>
                        </div>
                    }
                    @if (field.showAlignmentButtons) {
                        <div
                            role="radiogroup"
                            class="agpr-textStyleField-alignmentButtons"
                            [attr.aria-label]="'PageBuilder.formField.tooltip.fontAlignment' | localize"
                        >
                            <agpr-radio
                                class="agpr-textStyleField-button"
                                [id]="id + '_leftRadioButton'"
                                name="fontAlignment-{{id}}"
                                [value]="fontAlignmentEnum.left"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignLeft' | localize"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-align-left'"
                                hiddenLabel="PageBuilder.formField.tooltip.alignTextLeft"
                                [(ngModel)]="value.alignment"
                                (onClick)="setStyle(fontAlignmentEnum.left, 'alignment')"
                            ></agpr-radio>
                            <agpr-radio
                                class="agpr-textStyleField-button"
                                [id]="id + '_centerRadioButton'"
                                name="fontAlignment-{{id}}"
                                [value]="fontAlignmentEnum.center"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignCenter' | localize"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-align-center'"
                                hiddenLabel="PageBuilder.formField.tooltip.alignTextCenter"
                                [(ngModel)]="value.alignment"
                                (onClick)="setStyle(fontAlignmentEnum.center, 'alignment')"
                            ></agpr-radio>
                            <agpr-radio
                                class="agpr-textStyleField-button"
                                [id]="id + '_rightRadioButton'"
                                name="fontAlignment-{{id}}"
                                [value]="fontAlignmentEnum.right"
                                [iconTooltip]="'PageBuilder.formField.tooltip.alignRight' | localize"
                                [style]="radioTypesEnum.button"
                                [icon]="'fa-align-right'"
                                hiddenLabel="PageBuilder.formField.tooltip.alignTextRight"
                                [(ngModel)]="value.alignment"
                                (onClick)="setStyle(fontAlignmentEnum.right, 'alignment')"
                            ></agpr-radio>
                        </div>
                    }
                </div>
                <div class="agpr-textStyleField-fieldRow agpr-textStyleField-fieldRow--colorRow">
                    <div class="agpr-textStyleField-fieldRow-item agpr-textStyleField-fieldRow-item--color">
                        <agpr-color-picker-field
                            [id]="id + '_textColorPicker'"
                            [field]="colorPickerField"
                            [value]="value.color"
                            (changes)="setStyle($event, colorPickerField.property)"
                        ></agpr-color-picker-field>
                    </div>
                    @if (field.showBackgroundColor) {
                        <div class="agpr-textStyleField-fieldRow-item">
                            <agpr-color-picker-field
                                [id]="id + '_backgroundColorPicker'"
                                [field]="backgroundColorField"
                                [value]="value.backgroundColor"
                                (changes)="setStyle($event, backgroundColorField.property)"
                            ></agpr-color-picker-field>
                        </div>
                    }
                    @if (field.customBackgroundColorTemplate) {
                        <div class="agpr-textStyleField-fieldRow-item">
                            <ng-container
                                [ngTemplateOutlet]="field.customBackgroundColorTemplate"
                            ></ng-container>
                        </div>
                    }
                </div>
            }
        </div>

        @if (!hidePadding) {
            <agpr-block-padding
                class="agpr-textStyleField-blockPadding"
                [id]="id + '_padding'"
                [(padding)]="value.padding"
                [headerClass]="blockPaddingHeaderClass"
                [headerLabelHeading]="blockPaddingLabelSemibold"
                (paddingChanged)="setStyle($event, 'padding')"
            ></agpr-block-padding>
        }
    } @else {
        <div class="agpr-textStyleField">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                    {{ field.label | localize }}
                </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    }
</div>
